import React from 'react';

import { useTheme } from '@mui/material/styles';

import DeleteIcon from '@mui/icons-material/DeleteOutline';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const DeleteActionButton = (props: IBaseActionButtonProps) => {
  const theme = useTheme();

  const { classes } = useStyles();

  // styles={{
  //   width: theme.spacing(4),
  //   height: theme.spacing(4),
  //   color: theme.palette.error.main,
  // }}
  /* <DeleteIcon className={classes.icon} /> */
  return (
    <BaseActionButton
      {...props}
      styles={{
        color: theme.palette.error.main,
      }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round">
        <path d="M3 6h18"></path>
        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
        <line x1="10" x2="10" y1="11" y2="17"></line>
        <line x1="14" x2="14" y1="11" y2="17"></line>
      </svg>
    </BaseActionButton>
  );
};

export default DeleteActionButton;
